"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="ConversationHeader.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxConversationHeader object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxConversationHeader = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxDisplayPerson_1 = require("./HxDisplayPerson");
var HxMessageHeaderServerIdPair_1 = require("./HxMessageHeaderServerIdPair");
var HxStringPair_1 = require("./HxStringPair");
var HxConversationHeader = /** @class */ (function (_super) {
    __extends(HxConversationHeader, _super);
    function HxConversationHeader(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxConversationHeader, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxConversationHeader.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case 'B9':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case '151A':
                        this.canDelete = v;
                        break;
                    case '1277':
                        this.canModify = v;
                        break;
                    case 'D8F':
                        var categoriesValues = v;
                        this.categories = new Array(categoriesValues.length);
                        for (var i = 0; i < categoriesValues.length; i++) {
                            this.categories[i] = categoriesValues[i];
                        }
                        break;
                    case '4B2':
                        this.conversationId = new HxObjectID_1.default(v);
                        break;
                    case 'C7':
                        this.conversationViewMode = v;
                        break;
                    case 'B7':
                        this.countErrors = v;
                        break;
                    case 'AA':
                        this.countUnread = v;
                        break;
                    case '610':
                        this.displayNameCount = v;
                        break;
                    case '60F':
                        var displayNamesValues = v;
                        this.displayNames = new Array(displayNamesValues.length);
                        for (var i = 0; i < displayNamesValues.length; i++) {
                            this.displayNames[i] = HxDisplayPerson_1.deserializeHxDisplayPerson(displayNamesValues[i]);
                        }
                        break;
                    case 'DCA':
                        this.displayTime = new Date(v);
                        break;
                    case '4B3':
                        this.draftConversationHeaderId = new HxObjectID_1.default(v);
                        break;
                    case 'C2':
                        this.hasDraft = v;
                        break;
                    case '380':
                        this.hasFileAttachment = v;
                        break;
                    case 'AE':
                        this.hasMeetingContent = v;
                        break;
                    case 'E0C':
                        this.hasSharingMessageAction = v;
                        break;
                    case '1423':
                        this.hasUnreadActionableMessage = v;
                        break;
                    case 'AD':
                        this.importance = v;
                        break;
                    case 'B3':
                        this.isEncrypted = v;
                        break;
                    case '965':
                        this.isExpandable = v;
                        break;
                    case '1421':
                        this.isExternalSender = v;
                        break;
                    case 'A9':
                        this.isFlagged = v;
                        break;
                    case 'B1':
                        this.isForwardedMail = v;
                        break;
                    case '1292':
                        this.isPinned = v;
                        break;
                    case 'B0':
                        this.isRepliedMail = v;
                        break;
                    case 'AC':
                        this.isRestricted = v;
                        break;
                    case 'B2':
                        this.isSigned = v;
                        break;
                    case '14FF':
                        var itemClassesValues = v;
                        this.itemClasses = new Array(itemClassesValues.length);
                        for (var i = 0; i < itemClassesValues.length; i++) {
                            this.itemClasses[i] = itemClassesValues[i];
                        }
                        break;
                    case '96A':
                        this.lastAccessedTime = new Date(v);
                        break;
                    case '1522':
                        this.latestDraft = HxMessageHeaderServerIdPair_1.deserializeHxMessageHeaderServerIdPair(v);
                        break;
                    case 'BC1':
                        this.latestMeetingHeaderId = new HxObjectID_1.default(v);
                        break;
                    case 'BC2':
                        this.latestMeetingHeaderType = v;
                        break;
                    case '1523':
                        this.latestMeetingMessageHeader = HxMessageHeaderServerIdPair_1.deserializeHxMessageHeaderServerIdPair(v);
                        break;
                    case '1524':
                        this.latestMessageHeader = HxMessageHeaderServerIdPair_1.deserializeHxMessageHeaderServerIdPair(v);
                        break;
                    case 'D16':
                        this.latestMessageIsOnlyToMe = v;
                        break;
                    case '11AA':
                        this.latestSearchHitId = new HxObjectID_1.default(v);
                        break;
                    case 'DF9':
                        this.latestViewId = new HxObjectID_1.default(v);
                        break;
                    case '768':
                        this.mentionedMe = v;
                        break;
                    case '500':
                        this.messageHeaderCount = v;
                        break;
                    case '4FF':
                        this.messageHeadersId = new HxObjectID_1.default(v);
                        break;
                    case '9C1':
                        this.messageHeadersDownloadStatus = v;
                        break;
                    case '6FD':
                        this.mostRecentDisplayName = v;
                        break;
                    case '588':
                        this.parentViewType = v;
                        break;
                    case 'DF2':
                        this.photoEmailAddress = v;
                        break;
                    case 'A8':
                        this.preview = v;
                        break;
                    case '4EA':
                        this.richContentThumbnailsId = new HxObjectID_1.default(v);
                        break;
                    case 'E1E':
                        this.scheduledReturnTime = new Date(v);
                        break;
                    case 'DDA':
                        this.scheduleStatus = v;
                        break;
                    case '808':
                        this.senderEmailAddress = v;
                        break;
                    case '1500':
                        this.senderEmailAddressType = v;
                        break;
                    case 'C4':
                        this.sendingCount = v;
                        break;
                    case '2FB':
                        this.serverId = v;
                        break;
                    case '1501':
                        this.size = v;
                        break;
                    case 'DCB':
                        this.sortTime = new Date(v);
                        break;
                    case 'A3':
                        this.subject = v;
                        break;
                    case 'E0D':
                        this.suggestedSharingFolderName = v;
                        break;
                    case 'D8E':
                        this.tailoredEventType = v;
                        break;
                    case 'AE0':
                        this.topResultsRelevancy = v;
                        break;
                    case '100B':
                        var truncatedMentionsValues = v;
                        this.truncatedMentions = new Array(truncatedMentionsValues.length);
                        for (var i = 0; i < truncatedMentionsValues.length; i++) {
                            this.truncatedMentions[i] = HxStringPair_1.deserializeHxStringPair(truncatedMentionsValues[i]);
                        }
                        break;
                    case '585':
                        this.viewHandle = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxConversationHeader.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxConversationHeader.prototype.getConversation = function (sessionId) {
        return this.activeSet.getObject(this.conversationId, sessionId).then(function (result) { return result; });
    };
    HxConversationHeader.prototype.getDraftConversationHeader = function (sessionId) {
        return this.activeSet.getObject(this.draftConversationHeaderId, sessionId).then(function (result) { return result; });
    };
    HxConversationHeader.prototype.getLatestMeetingHeader = function (sessionId) {
        return this.activeSet.getObject(this.latestMeetingHeaderId, sessionId).then(function (result) { return result; });
    };
    HxConversationHeader.prototype.getLatestSearchHit = function (sessionId) {
        return this.activeSet.getObject(this.latestSearchHitId, sessionId).then(function (result) { return result; });
    };
    HxConversationHeader.prototype.getLatestView = function (sessionId) {
        return this.activeSet.getObject(this.latestViewId, sessionId).then(function (result) { return result; });
    };
    HxConversationHeader.prototype.getMessageHeaders = function (sessionId) {
        return this.activeSet.getCollection(this.messageHeadersId, sessionId);
    };
    HxConversationHeader.prototype.getRichContentThumbnails = function (sessionId) {
        return this.activeSet.getCollection(this.richContentThumbnailsId, sessionId);
    };
    HxConversationHeader.prototype.getView = function (sessionId) {
        return this.activeSet.getObjectFromHandle(this.viewHandle, HxObjectType_1.default.HxView, sessionId).then(function (result) { return result; });
    };
    return HxConversationHeader;
}(HxObject_1.default));
exports.HxConversationHeader = HxConversationHeader;
exports.default = HxConversationHeader;
